import { mailboxReducers } from '../reducers'

export const mailboxRootReducers = {
  mailbox: mailboxReducers,
}
